import html from "../assets/Skills/html.png";
import css from "../assets/Skills/css.png";
import react from "../assets/Skills/react.png";
import git from "../assets/Skills/github.png";
import js from "../assets/Skills/javascript.png";
import redux from "../assets/Skills/redux.png"
import sass from "../assets/Skills/sass.png"
import mui from "../assets/Skills/mu5.png"
import node from "../assets/Skills/node.png"
import reactnative from "../assets/Skills/react_native.png"
import mongoDB from "../assets/Skills/mdb.png"
import rtl from "../assets/Skills/rtl.png"
import bootstrap from "../assets/Skills/bootstrap5.png"
import chakraUI from "../assets/Skills/chakraUI.png"
import java from "../assets/Skills/java.png"
import python from "../assets/Skills/python.png"
import gluestack from "../assets/Skills/gluestack.png"
import tailwindCss from "../assets/Skills/tailwind-css-icon.png"
import rnpLogo from "../assets/Skills/rnp.png"
const skillsList= [
  {
    name: "Python",
    icon: python,
    bgColor: "#edf3f8",
  },
  {
    name: "Java",
    icon: java,
    bgColor: "#edf3f8",
  },
  {
    name: "Html",
    icon: html,
    bgColor: "#edf3f8",
  },
  {
    name: "Css",
    icon: css,
    bgColor: "#edf3f8",
  },
  {
    name: "Bootstrap5",
    icon: bootstrap,
    bgColor: "#edf3f8",
  },
  {
    name: "Javascript",
    icon: js,
    bgColor: "#edf3f8",
  },
  {
    name: "Git/Github",
    icon: git,
    bgColor: "#edf3f8",
  },
  {
    name: "Sass",
    icon: sass,
    bgColor: "#edf3f8",
  },
  {
    name: "Reactjs",
    icon: react,
    bgColor: "#edf3f8",
  },
  {
    name: "Redux",
    icon: redux,
    bgColor: "#edf3f8",
  },
  {
    name: "ChakraUI",
    icon: chakraUI,
    bgColor: "#edf3f8",
  },
  {
    name: "Mui5",
    icon: mui,
    bgColor: "#edf3f8",
  },
  {
    name: "React Native",
    icon: reactnative,
    bgColor: "#edf3f8",
  },
  {
    name: "React Testing Library",
    icon: rtl,
    bgColor: "#edf3f8",
  },
  {
    name: "Nodejs",
    icon: node,
    bgColor: "#edf3f8",
  },
  {
    name: "MongoDB",
    icon: mongoDB,
    bgColor: "#edf3f8",
  },
  {
    name: "GlueStack",
    icon: gluestack,
    bgColor: "#edf3f8",
  },
  {
    name: "TailwindCss",
    icon: tailwindCss,
    bgColor: "#edf3f8",
  },
  {
    name: "React Native Papers",
    icon:rnpLogo,
    bgColor: "#edf3f8",
  },

];
export default skillsList;